export enum MapProvider {
  Geoserver = 'geoserver',
  API = 'api',
}

export interface ILayerProviderSettings {
  provider: MapProvider;
}
